import { render, staticRenderFns } from "./StrukturOrganisasi.vue?vue&type=template&id=e8400c16&scoped=true"
import script from "./StrukturOrganisasi.vue?vue&type=script&lang=js"
export * from "./StrukturOrganisasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8400c16",
  null
  
)

export default component.exports